export default __webpack_public_path__ + "static/media/pricing.8d557a33.png";